<template>
  <v-card dark class="elevation-5">
    <v-toolbar
      :class="{
        verde: node.json.modulo.mod_active,
        buildermodule: node.json.modulo.builder == true
      }"
    >
      <div>
        <div class="subheading" style="cursor:pointer;" @click="openEdit(node)">
          {{ node.json.modulo.mod_titulo }}
        </div>
        <span class="caption">({{ node.json.modulo.mod_tabela }})</span>
      </div>

      <v-icon
        v-if="node.json.modulo.mod_acao_add != ''"
        color="grey darken-3"
        class="ma-1 botaofake"
        >add</v-icon
      >
      <v-icon
        v-if="node.json.modulo.mod_acao_edit != ''"
        color="grey darken-3"
        class="ma-1 botaofake"
        >edit</v-icon
      >
      <v-icon
        v-if="node.json.modulo.mod_acao_del != ''"
        color="grey darken-3"
        class="ma-1 botaofake"
        >delete</v-icon
      >
      <v-icon
        v-if="node.json.modulo.mod_acao_view != ''"
        color="grey darken-3"
        class="ma-1 botaofake"
        >remove_red_eye</v-icon
      >

      <v-speed-dial absolute top right open-on-hover direction="left">
        <v-btn slot="activator" color="blue darken-2" dark fab small>
          <v-icon>build</v-icon>
        </v-btn>

        <v-btn color="yellow" dark small fab @click="builderGen(node)">
          <v-icon>share</v-icon>
        </v-btn>

        <v-btn color="blue" dark small fab @click="openEdit(node)">
          <v-icon>edit</v-icon>
        </v-btn>

        <v-btn color="red" dark small fab @click="$emit('meExcluir')">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-speed-dial>
    </v-toolbar>

    <v-card-text v-if="node.json.campos">
      <draggable
        :list="camposordem"
        v-if="node.json.modulo.builder !== true"
        @end="onEndSort"
      >
        <div
          class="box"
          :index="cindex"
          xs3
          v-for="(campo, cindex) in camposordem"
          :key="cindex"
        >
          <campo
            :campo="campo"
            @dropme="dropMe(cindex)"
            @cloneme="cloneMe(campo)"
            :modulo="node"
          ></campo>
        </div>
      </draggable>
      <div
        v-else
        class="box"
        :index="cindex"
        xs3
        v-for="(campo, cindex) in camposordem"
        :key="cindex"
      >
        <campo
          :campo="campo"
          @dropme="dropMe(cindex)"
          @cloneme="cloneMe(campo)"
          :modulo="node"
        ></campo>
      </div>

      <div style="clear:both;"></div>
    </v-card-text>

    <v-btn
      color="green"
      dark
      small
      absolute
      bottom
      right
      fab
      @click="addCampo()"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-btn
      color="grey"
      dark
      small
      absolute
      top
      left
      fab
      style="margin-left:-35px;zoom: 70%; '-moz-transform': 'scale(70%)';"
      @click="$emit('meClone')"
    >
      <v-icon>file_copy</v-icon>
    </v-btn>

    <v-dialog
      v-if="editDialog"
      width="800"
      hide-overlay
      transition="dialog-bottom-transition"
      v-model="editDialog"
    >
      <modedit :node="node" @close="saiuDaEdicao()"></modedit>
    </v-dialog>
    <v-textarea
      v-if="generated != null && generated != ''"
      v-model="generated"
      solo
      light
    ></v-textarea>
  </v-card>
</template>

<script>
/* eslint-disable */

const Campo = global.reqClass.requirecmpmix("@/admin/metadmin/inc/campo");
const Modedit = global.reqClass.requirecmpmix("@/admin/metadmin/inc/modedit");
const draggable = ()=>import("vuedraggable");


export default {
  props: ["node"],
  data() {
    return {
      editDialog: false,
      generated: null
    };
  },
  beforeMount() {
    this.node.json.campos.map((e, i) => {
      e.ord = i;
      return e;
    });

    if (
      this.node.json.modulo.mod_titulo == "" ||
      this.node.json.modulo.mod_tabela == ""
    )
      this.editDialog = this.node;
  },

  computed: {
    camposordem() {
      return this.node.json.campos.sort((a, b) => a.ord - b.ord);
    }
  },
  methods: {
    onEndSort(ev) {
      this.node.json.campos.splice(
        ev.newIndex,
        0,
        this.node.json.campos.splice(ev.oldIndex, 1)[0]
      );
      this.node.json.campos.map((e, i) => {
        e.ord = i;
        return e;
      });

      let res = global.modulosController.updateRest(
        this.node.json.modulo.mod_tabela
      );
    },

    saiuDaEdicao() {
      if (
        this.node.json.modulo.mod_titulo == "" ||
        this.node.json.modulo.mod_tabela == ""
      ) {
        this.editDialog = false;
        this.$emit("meApague");

        return;
      }

      let res = global.modulosController.updateRest(
        this.node.json.modulo.mod_tabela
      );
      this.editDialog = false;
    },

    openEdit(node) {
      if (node.json.modulo.builder == true) return;

      this.editDialog = node;
    },
    dropMe(index) {
      if (this.node.json.modulo.builder == true) return;

      this.node.json.campos.splice(index, 1);

      let res = global.modulosController.updateRest(
        this.node.json.modulo.mod_tabela
      );
    },
    cloneMe(campo) {
      if (this.node.json.modulo.builder == true) return;

      console.log("qveio", campo);
      let copy = _.cloneDeep(campo);
      copy.cmp_coluna = "";
      copy.cmp_titulo = "";
      copy.ord = 999;
      this.node.json.campos.push(copy);
    },
    addCampo() {
      if (this.node.json.modulo.builder == true) return;

      this.node.json.campos.push({
        cmp_titulo: "",
        cmp_coluna: "",
        cmp_dica: "",
        cmp_idioma: "",
        cmp_type: "VARCHAR",
        cmp_tamanho: "255",
        cmp_pk: false,
        cmp_add: true,
        cmp_edit: true,
        cmp_view: true,
        cmp_flow: "",
        cmp_extra: "",
        cmp_valida: "",
        cmp_ordena: "",
        cmp_filtro: true,
        cmp_viewmode: false,
        cmp_extra: null,
        cmp_ordem: true,
        cmp_conta: "",
        cmp_showfn: "",
        valorpadrao: "",
        cmp_manual: "",
        cmp_tipo: "",
        ord: 999,
        cmp_lista: true,
        cmp_join_tabela: "",
        cmp_join_campo: "",
        cmp_join_mostra: "",
        cmp_join_tipo: "select",
        cmp_join_restricao: "",
        cmp_join_tabelann: "",
        cmp_join_tabelac1: "",
        cmp_join_tabelac2: "",
        componente: "",
        param: "",
        fotos: []
      });
    },
    builderGen(node) {
      let model_mod = {
        //            "builder":true,
        //            "mod_titulo": (title||table||'Noname'),
        //            "mod_tabela": table,
        mod_paginacao: "20",
        mod_numero: true,
        tpl: "tabelado",
        tplparam: "",
        //            "mod_secaomen": section||'',
        rodape: [],
        mod_acao_add: "Adicionar",
        mod_acao_edit: true,
        mod_acao_del: true,
        mod_acao_view: true,
        mod_fn_add: "",
        mod_fn_edit: "",
        mod_fn_del: "",
        mod_fn_view: "",
        mod_fn_flow: "",
        antes: "",
        aomeio: "",
        final: "",
        pre_insert: "",
        pre_update: "",
        pre_delete: "",
        pos_insert: "",
        pos_update: "",
        pos_delete: "",
        mod_lowhere: "",
        mod_lojson:
          "{filtro:true,gc:true,titulo:true,rodape:true,paginacao:true}",
        classe: "",
        classe_display: "",
        classe_display_post: "",
        cache: "",
        view_sql: "",
        exibicao: "nome"
        //            "mod_active": true
      };

      let model_col0 = {
        cmp_add: true,
        cmp_edit: true,
        cmp_view: true,
        cmp_filtro: true,
        cmp_viewmode: false,
        cmp_ordem: true,
        cmp_lista: true
      };

      let model_col = {
        //            "cmp_titulo": (title||column||'Noname'),
        //            "cmp_coluna": column,
        cmp_dica: "",
        cmp_idioma: "",
        //            "cmp_type": sqltype||"VARCHAR",
        cmp_tamanho: "255",
        //            "cmp_pk": false,
        cmp_flow: "",
        cmp_valida: "",
        cmp_ordena: "",
        cmp_extra: "",
        cmp_conta: "",
        cmp_showfn: "",
        valorpadrao: "",
        cmp_manual: "",
        //            "cmp_tipo": tipo||"text",
        cmp_valores: "",
        //            "ord": 1,
        //            "cmp_join_tabela": "",
        //            "cmp_join_campo": "",
        //            "cmp_join_mostra": "",
        //            "cmp_join_tipo": "select",
        cmp_join_restricao: "",
        //            "cmp_join_tabelann": "",
        //            "cmp_join_tabelac1": "",
        //            "cmp_join_tabelac2": "",
        //            "modulo": "",
        componente: "",
        param: "",
        fotos: []
      };

      let model_valida = {
        "[v => !!v || titulo+' obrigatório']": "text",
        "[v => (v!==null && v!=='') || titulo+' obrigatório']": "array",
        "[v => v.length>0 || titulo+' obrigatório']": "NxN"
      };

      let o = node.json;

      let out = "";
      out += `    
creator.add(
  new Module("${o.modulo.mod_tabela}", "${o.modulo.mod_titulo}", "${o.modulo.mod_secaomen}")
`;

      ///COLUNAS
      for (let col of o.campos) {
        out += `    .col(new Column("${col.cmp_coluna}","${col.cmp_titulo}", "${col.cmp_tipo}", "${col.cmp_type}")
`;

        if (col["cmp_pk"] == true) {
          out += `      .setAs("pk")
`;
        }

        let st = [];
        let sf = [];

        ///PROPRIEDADES DO CAMPO0
        for (let key in model_col0) {
          let val = model_col0[key];
          if (
            JSON.stringify(col[key]) != JSON.stringify(val) &&
            col[key] !== undefined &&
            col[key] !== "" &&
            col[key] !== null
          ) {
            let showkey =
              key.substring(0, 4) == "cmp_" ? key.substring(4) : key;
            if (col[key] == true) st.push(showkey);
            if (col[key] == false) sf.push(showkey);
          }
        }

        if (st.length > 1) {
          out += `      .prop(["${st.join('","')}"], true)
`;
        } else if (st.length == 1) {
          out += `      .${st[0]}(true)
`;
        }

        if (sf.length > 1) {
          out += `      .prop(["${sf.join('","')}"], false)
`;
        } else if (sf.length == 1) {
          out += `      .${sf[0]}(false)
`;
        }

        if (
          col["cmp_tipo"] == "join" &&
          col["cmp_join_tabela"] != "" &&
          col["cmp_join_tabela"] != "-1"
        ) {
          out += `      .addJoin("${col["cmp_join_tabela"]}", "${col["cmp_join_campo"]}", "${col["cmp_join_mostra"]}", "${col["cmp_join_tipo"]}"`;
          if (col["cmp_join_tabelann"] != "") {
            out += `, "${col["cmp_join_tabelann"]}", "${col["cmp_join_tabelac1"]}", "${col["cmp_join_tabelac2"]}"`;
          }
          out += `)
`;
        }

        ///PROPRIEDADES DO CAMPO
        for (let key in model_col) {
          let val = model_col[key];
          if (
            JSON.stringify(col[key]) != JSON.stringify(val) &&
            col[key] !== undefined &&
            col[key] !== "" &&
            col[key] !== null
          ) {
            let showkey =
              key.substring(0, 4) == "cmp_" ? key.substring(4) : key;
            if (showkey == "valida" && model_valida[col[key]] != null)
              out += `      .addValidation("${model_valida[col[key]]}")
`;
            else
              out += `      .${showkey}(${JSON.stringify(col[key])})
`;
          }
        }

        out += `
    )
`;
      }

      //Gera AUDIT
      let replacement = `
    .col(new Column("created_by","Criado Por", "join", "INT")
      .prop(["add","edit","filtro","lista"], false)
      .addJoin("${global.config.pessoa}", "id", "nome", "select")

    )
    .col(new Column("last_edit_by","Modificado Por", "join", "INT")
      .prop(["add","edit","filtro","lista"], false)
      .addJoin("${global.config.pessoa}", "id", "nome", "select")

    )
    .col(new Column("created_on","Criado Em", "datetime", "DATETIME")
      .prop(["add","edit","filtro","lista"], false)

    )
    .col(new Column("last_edit_on","Modificado Em", "datetime", "DATETIME")
      .prop(["add","edit","filtro","lista"], false)

    )
`.trim();
      if (out.indexOf(replacement) != -1) {
        out = out.replace(replacement, ".addAudit()");
      }

      ///PROPRIEDADES DO MODULO
      for (let key in model_mod) {
        let val = model_mod[key];
        if (key == "rodape" && o.modulo[key] == "") val = "";
        if (
          key == "rodape" &&
          JSON.stringify(o.modulo[key]) == JSON.stringify([])
        )
          val = [];

        if (
          JSON.stringify(o.modulo[key]) != JSON.stringify(val) &&
          o.modulo[key] !== undefined &&
          o.modulo[key] !== null
        ) {
          let showkey = key.substring(0, 4) == "mod_" ? key.substring(4) : key;
          if (showkey == "tplparam")
            out += `    .${showkey}(\`${o.modulo[key]}\`)
`;
          else
            out += `    .${showkey}(${JSON.stringify(o.modulo[key])})
`;
        }
      }

      ///COLUNAS
      if (o.custom.length > 0) {
        out += "\n";
      }
      for (let col of o.custom) {
        out += `    .act(new Action("${col.cus_pk}")
      .exibe("${col.cus_exibe}")
      .executa("${col.cus_executa}")
      .massa("${col.cus_massa}")
    )
`;
      }

      //FIM
      out += `    
)
`;

      this.generated = out;
      console.log(out);
    }
  },
  components: {
    Campo,
    draggable,
    Modedit
  }
};
</script>

<style scoped>
.box {
  float: left;
  margin: 3px;
  width: 130px;
  height: 80px;
}
.verde {
  background-color: rgb(1, 54, 1);
}
.botaofake {
  border-radius: 0;
}
.buildermodule {
  background-color: #ccc;
}
</style>
